<template>
  <div class="victory">
    <img :src="selectedImage">
  </div>
</template>

<script>

export default {
  data: () => ({
    images: [
      '/images/trailerpagk.png',
      '/images/dribbble_images_portrait-01.jpg',
      '/images/drbl_f-off.png',
      '/images/fuckyou.png',
      '/images/fuck_off_800x600.jpg'
    ],
    selectedImage: ''
  }),
  created () {
    let idx = Math.floor(Math.random() * this.images.length)
    this.selectedImage = this.images[idx]
  }
}
</script>
